import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import Faq from "../components/Faq";
import { contact } from "../mock";

export default function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ | Medicine Courier from India | ShipMeds"
        description="Answers to common questions about couriering medicines abroad from India — which medicines, prescriptions, delivery time, charges and payment options."
        path="/faq"
      />
      <PageHero title="Frequently Asked Questions" subtitle="Answers to the most common questions about couriering medicines internationally." crumb="FAQ" />
      <Faq />
      <section className="pb-20 -mt-6">
        <div className="max-w-3xl mx-auto px-4">
          <div className="bg-gradient-to-r from-teal-700 to-teal-600 rounded-2xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-2">Still have questions?</h3>
            <p className="text-teal-100 mb-5">Our experts are available 24x7 to help you ship your medicines safely.</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-3 rounded-lg transition-colors"><MessageCircle className="w-5 h-5" /> WhatsApp Us</a>
              <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-teal-700 font-bold px-6 py-3 rounded-lg hover:bg-teal-50 transition-colors">Contact Form</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
